import { useMemo } from "react";
import { useCompaniesByCustomerId } from "./useCompaniesByCustomerId";
import { useSitesByCompanyId } from "./useSitesByCompanyId";

export function useCompanyAndSiteIds(companyName?: string, siteName?: string, customerId?: number) {
  const companies = useCompaniesByCustomerId(customerId);

  const companyId = useMemo(() => {
    if (companies && companyName) {
      return companies.data?.find((c) => c.name === companyName)?.id;
    }
  }, [companies, companyName]);

  const sites = useSitesByCompanyId(companyId);

  const siteId = useMemo(() => {
    if (sites.data && siteName) {
      return sites.data?.find((c) => c.name === siteName)?.id;
    }
  }, [sites.data, siteName]);

  return { companyId, siteId };
}
